import IamRouter from '@generalScope/ceRouter/iam'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'
import { featureMenuHiddenCheck, hasServices, setupKeys } from '@/utils/auth'
import Layout from '@/layouts/RouterView'
import Organization from '@IAM-ee/views/organization'
import i18n from '@/locales'
import store from '@/store'
const CommandRecord = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/command-log')
const Log = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/log')
const LogManage = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/log-manage')
const Cloudevent = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@Cloudenv/views/cloudevent')
const ThirdParty = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/third-party')
const WorkflowConfig = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/workflow-config')

export default {
  index: 91,
  meta: {
    label: i18n.t('dictionary.menu_iam_security'),
    t: 'dictionary.menu_iam_security',
    icon: 'menu-iam',
  },
  menus: [...IamRouter.menus.map((item, index) => {
    if (index === 0) {
      const [first, ...last] = item.submenus
      item.submenus = [
        first,
        {
          path: '/organization',
          meta: {
            label: i18n.t('iamee.organization'),
            permission: 'organizations_list',
            t: 'iamee.organization',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.organization')) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          subGroup: 'iam',
          component: Layout,
          children: [
            {
              name: 'Organization',
              path: '',
              component: Organization,
            },
          ],
        },
        ...last,
      ]
    }
    return item
  }),
  {
    meta: {
      label: i18n.t('system.log_audit'),
    },
    subGroup: 'log_audit',
    submenus: [
      {
        path: '/log',
        meta: {
          label: i18n.t('system.text_17'),
          permission: 'log_list',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.log')) {
              return true
            }
            if (!hasServices('log') || store.getters.isSysCE) {
              return true
            }
            return featureMenuHiddenCheck(menu)
          },
          t: 'dictionary.actions',
        },
        component: Layout,
        children: [
          {
            name: 'Log',
            path: '',
            component: Log,
          },
        ],
      },
      {
        path: '/log-manage',
        meta: {
          label: i18n.t('dictionary.log_manage'),
          permission: 'log_manage_list_splitable',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.log_manage')) {
              return true
            }
            if (!setupKeys.hasVersionedSetupKey({ '3.0': ['auth'] }, true) || !store.getters.isAdminMode) {
              return true
            }
            return featureMenuHiddenCheck(menu)
          },
        },
        component: Layout,
        children: [
          {
            name: 'LogManage',
            path: '',
            component: LogManage,
          },
        ],
      },
      {
        path: '/cloudevent',
        meta: {
          label: i18n.t('dictionary.cloudevents'),
          permission: 'cloudevents_list',
          t: 'dictionary.cloudevents',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.cloudevent')) {
              return true
            }
            if (!hasServices('cloudevent')) {
              return true
            }
            return featureMenuHiddenCheck(menu) || store.getters.isSysCE
          },
        },
        component: Layout,
        children: [
          {
            name: 'Cloudevent',
            path: '',
            component: Cloudevent,
          },
        ],
      },
      {
        path: '/command-log',
        meta: {
          label: i18n.t('dictionary.command_log'),
          permission: 'commandlogs_list',
          t: 'dictionary.command_log',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.command_log')) {
              return true
            }
            if (!store.getters.isAdminMode) {
              return true
            }
            return featureMenuHiddenCheck(menu)
          },
        },
        component: Layout,
        children: [
          {
            name: 'CommandRecord',
            path: '',
            component: CommandRecord,
          },
        ],
      },
    ],
  },
  {
    meta: {
      label: i18n.t('system.text_12'),
    },
    subGroup: 'workflow',
    submenus: [
      {
        path: '/processmanage',
        meta: {
          label: i18n.t('system.text_13'),
          permission: 'process_manage_list',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.processmanage')) {
              return true
            }
            if (!hasServices('itsm') || store.getters.isSysCE) {
              return true
            }
            return featureMenuHiddenCheck(menu)
          },
        },
        component: Layout,
        children: [
          {
            name: 'WorkflowConfig',
            path: '',
            component: WorkflowConfig,
          },
        ],
      },
      {
        path: '/thirdparty',
        meta: {
          label: i18n.t('system.text_14'),
          permission: 'extra_users_create',
          hidden: (userInfo, menu) => {
            if (isScopedPolicyMenuHidden('sub_hidden_menus.thirdparty')) {
              return true
            }
            if (!hasServices('itsm') || !store.getters.isAdminMode || store.getters.isSysCE) {
              return true
            }
            return featureMenuHiddenCheck(menu)
          },
        },
        component: Layout,
        children: [
          {
            name: 'ThirdParty',
            path: '',
            component: ThirdParty,
          },
        ],
      },
    ],
  }],
}
